import { useEffect, useState } from "react";
import { Plus, Trash2, CheckCircle2 } from "lucide-react";
import AdminHeader from "../../components/layout/AdminHeader";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function AdminTasks() {
  const [list, setList] = useState([]);
  const [showNew, setShowNew] = useState(false);
  const [f, setF] = useState({ title: "", description: "", due_at: "", priority: "medium", status: "open" });

  const load = async () => {
    const { data } = await api.get("/tasks");
    setList(data);
  };
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!f.title.trim()) return;
    try {
      await api.post("/tasks", { ...f, due_at: f.due_at || null });
      toast.success("Task created");
      setShowNew(false); setF({ title: "", description: "", due_at: "", priority: "medium", status: "open" });
      load();
    } catch { toast.error("Failed"); }
  };

  const toggle = async (t) => {
    const next = t.status === "done" ? "open" : "done";
    await api.patch(`/tasks/${t.id}`, { status: next }); load();
  };
  const del = async (t) => { await api.delete(`/tasks/${t.id}`); load(); toast.success("Deleted"); };

  return (
    <div data-testid="page-admin-tasks">
      <AdminHeader breadcrumb="Operations" title="Tasks" subtitle="Follow-ups, action items, and internal to-dos."
        actions={<button onClick={() => setShowNew(true)} className="btn-gold" data-testid="tasks-new"><Plus className="h-3.5 w-3.5" /> New task</button>} />
      <div className="p-8">
        {showNew && (
          <div className="admin-card mb-6 space-y-3" data-testid="task-new-form">
            <input className="admin-input" placeholder="Title" value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} data-testid="task-title" />
            <textarea rows={2} className="admin-input" placeholder="Description" value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} data-testid="task-description" />
            <div className="grid grid-cols-2 gap-3">
              <input type="datetime-local" className="admin-input" value={f.due_at} onChange={(e) => setF({ ...f, due_at: e.target.value })} data-testid="task-due" />
              <select className="admin-select" value={f.priority} onChange={(e) => setF({ ...f, priority: e.target.value })} data-testid="task-priority">
                <option value="low">Low</option><option value="medium">Medium</option><option value="high">High</option>
              </select>
            </div>
            <div className="flex gap-2">
              <button onClick={create} className="btn-espresso" data-testid="task-create">Create</button>
              <button onClick={() => setShowNew(false)} className="btn-ghost-espresso">Cancel</button>
            </div>
          </div>
        )}
        <div className="admin-card">
          <table className="w-full text-sm">
            <thead className="text-[11px] uppercase tracking-[0.15em] text-altura-charcoal/50">
              <tr className="border-b border-altura-espresso/10"><th className="text-left py-3 px-2">Task</th><th className="text-left py-3 px-2">Due</th><th className="text-left py-3 px-2">Priority</th><th className="text-left py-3 px-2">Status</th><th></th></tr>
            </thead>
            <tbody>
              {list.map((t) => (
                <tr key={t.id} className={`border-b border-altura-espresso/5 ${t.status === "done" ? "opacity-60" : ""}`} data-testid={`task-row-${t.id}`}>
                  <td className="py-3 px-2">
                    <div className={`font-medium text-altura-espresso ${t.status === "done" ? "line-through" : ""}`}>{t.title}</div>
                    {t.description && <div className="text-xs text-altura-charcoal/60 mt-0.5">{t.description}</div>}
                  </td>
                  <td className="py-3 px-2 font-mono text-xs">{t.due_at ? new Date(t.due_at).toLocaleString() : "—"}</td>
                  <td className="py-3 px-2"><span className="badge-soft capitalize">{t.priority}</span></td>
                  <td className="py-3 px-2"><span className="badge-gold capitalize">{t.status}</span></td>
                  <td className="py-3 px-2">
                    <button onClick={() => toggle(t)} className="text-altura-espresso/60 hover:text-altura-gold-dark mr-3" title="Toggle status" data-testid={`task-toggle-${t.id}`}><CheckCircle2 className="h-4 w-4" /></button>
                    <button onClick={() => del(t)} className="text-altura-espresso/60 hover:text-altura-burgundy" title="Delete" data-testid={`task-delete-${t.id}`}><Trash2 className="h-4 w-4" /></button>
                  </td>
                </tr>
              ))}
              {list.length === 0 && <tr><td colSpan="5" className="text-center py-10 text-altura-charcoal/50">No tasks yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
